module.exports = __webpack_public_path__ + "static/media/sajad-nori-uRIil5LFBaI-unsplash.b034cc0b.jpg";